var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        [
          _c(
            "el-main",
            [
              _c("div", { staticClass: "mx-auto" }, [
                _c("h3", [_vm._v("直接建立商品")]),
              ]),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.form,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "經銷商" } },
                    [
                      _c("selectCompany", {
                        attrs: { id: _vm.form.company_id },
                        on: {
                          "update:id": function ($event) {
                            return _vm.$set(_vm.form, "company_id", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "品號", prop: "ProductNo" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.ProductNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ProductNo", $$v)
                          },
                          expression: "form.ProductNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "品名", prop: "ProductNa" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.ProductNa,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ProductNa", $$v)
                          },
                          expression: "form.ProductNa",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "單價", prop: "UnitPrice" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.UnitPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "UnitPrice", _vm._n($$v))
                          },
                          expression: "form.UnitPrice",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("form")
                            },
                          },
                        },
                        [_vm._v("立即建立")]
                      ),
                      _c("el-button", [_vm._v("取消")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("hr"),
              _c(
                "div",
                { staticClass: "mx-auto" },
                [
                  _c("h3", { staticClass: "text-center" }, [
                    _vm._v("或是利用EXCEL文件上傳"),
                  ]),
                  _c("upload-excel", {
                    attrs: { "upload-action": _vm.upload },
                  }),
                  _c(
                    "a",
                    { attrs: { href: "./商品資料範例.csv" } },
                    [
                      _c("el-button", { attrs: { type: "success" } }, [
                        _vm._v("下載範例檔案 "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }